import orderViewInstance from '../instance'

const getPickupOrders = (page = 0, size = 10, pickupStatus, sortBy) => {
	return orderViewInstance.get('/orders/pickup'
		+ '?page=' + page + '&size=' + size
		+ (pickupStatus ? '&pickupStatus=' + pickupStatus : '')
		+ (sortBy ? '&sortBy=' + sortBy : ''),
	)
}

export default getPickupOrders
